import { useEffect, useState } from "react";
import PageContainer from "../components/PageContainer";
import PageTitle from "../components/PageTitle";
import CustomHr from "../components/CustomHr";
import TagLabel from "../components/TagLabel";
import ActivityLocationMap from "../components/mapTiler/ActivityLocationMap.jsx";
import ToFixMessage from "../components/ToFixMessage.jsx";
import { GreenButton } from "../components/buttons.js";
import ElementLabel from "../components/ElementLabel.jsx";
import Loader from '../components/Loader.jsx';
import getCountry from "../utils/getCountry.js";
import { useSearchParams, useNavigate } from "react-router-dom";
import UploadPhotos from "../components/UploadPhotos.jsx";
import { useDispatch, useSelector } from "react-redux";
import { getAdminActivities, setIsNeedRefresh } from "../redux/adminActivitiesSlice.ts";
import { setIsNeedHomeRefresh } from "../redux/userActivitiesSlice.js";
import CheckboxList from "../components/CheckboxList.jsx";
import { airCategories, landCategories, snowCategories, waterCategories, bestViewsCategories } from "../data/categoryList.js";
import QuillTextarea from "../components/QuillTextarea.js";
import AddCustomOptions from "../components/AddCustomOptions.jsx";
import { getAllCompanies } from "../redux/adminCompaniesSlice.js";
import { getPriceString } from "../utils/getPriceString.js";
import AlertMessage from '../components/AlertMessage.jsx';
import { setBacklink } from "../redux/backlinkSlice.js";

const AddEditActivity = () => {

    // Check if add or edit
    // Imposto il backlink su HandleActivities
    const [searchParams] = useSearchParams();
    const activityId = searchParams.get('activityId');
    const [isEditMode, setIsEditMode] = useState(false);
    const [activityData, setActivityData] = useState(null);
    const { data, isLoading } = useSelector(state => state.adminActivities);
    const dispatch = useDispatch();
    useEffect(() => {
        dispatch(setBacklink("/handle-activities"))
    }, [])
    useEffect(() => {
        if (!data && activityId) { // nel caso in modalità edit si refreshi
            dispatch(getAdminActivities({ selectionKey: '', selectionValue: '', sortBy: '', reverse: false, page: '', pageSize: '' }))
        } else if (activityId && data) {
            setIsEditMode(true);
            setActivityData(data.find(element => element._id === activityId));
        }
    }, [activityId, data])

    // Imposto inputData coi dati dell'attività trovata
    useEffect(() => {
        if (activityData) {
            console.log('Activity data found:', activityData);
            setInputData(activityData)
        }
    }, [activityData])

    // Handle inputData
    const [inputData, setInputData] = useState({
        isActive: false,
        activityType: [],
        category: [],
        title: null,
        summary: null,
        groupModel: [],
        difficultyLevel: [],
        availablePeriod: [],
        description: null,
        tags: [],
        price: [],
        priceNote: null,
        email: null,
        website: null,
        social: [],
        selectedRegion: [],
        coordinates: null,
        autoCountry: null,
        gallery: [],
        coverImageUrl: null,
        details: [],
        minimumGroup: null,
        recommendedAge: null,
        languages: [],
        program: [],
        servicesIncluded: [],
        accessibility: [],
        isByWeather: false,
        isExclusive: false,
        isPremium: false,
        cancellation: [],
        equipmentRentInfo: [],
        onsiteEquipment: [],
        precautions: [],
        customOptions: [],
        company: null,
        isMonthAdviced: false,
        isForInstagrammers: false,
        isExternalPaid: false,
    });
    
    useEffect(() => {
        console.log('inputData updated:', inputData);
    }, [inputData])

    const handleInputData = (event) => {
        setIsFieldsError(false);
        const { id, value, checked } = event.target;
        let fixedId;
        let fixedValue;
        if (id.slice(0, 7) === 'details') {
            fixedId = 'details';
            if (checked) {
                let detailsArray = [...inputData.details];
                detailsArray.push(value);
                fixedValue = detailsArray;
            } else {
                let detailsArray = inputData.details.filter(element => element !== value);
                fixedValue = detailsArray;
            };
        } else if (id === 'recommendedAge') {
            fixedId = id;
            fixedValue = parseInt(value);
        } else if (id.slice(0, 9) === 'languages') {
            fixedId = 'languages';
            if (checked) {
                let newLanguagesArray = [...inputData.languages];
                newLanguagesArray.push(value);
                fixedValue = newLanguagesArray;
            } else {
                let newLanguagesArray = inputData.languages.filter(element => element !== value);
                fixedValue = newLanguagesArray;
            };
        } else if (id === 'isByWeather') {
            fixedId = 'isByWeather';
            fixedValue = checked;
        } else if (id === 'isExclusive') {
            fixedId = 'isExclusive';
            fixedValue = checked;
        } else if (id.slice(0, 14) === 'selectedRegion') {
            fixedId = 'selectedRegion';
            if (checked) {
                console.log('value:', value);
                let newSelectedRegionArray = [...inputData.selectedRegion];
                newSelectedRegionArray.push(value);
                fixedValue = newSelectedRegionArray;
                console.log('newSelectedRegionArray:', newSelectedRegionArray);
            } else {
                console.log('value:', value);
                let newSelectedRegionArray = inputData.selectedRegion.filter(element => element !== value);
                fixedValue = newSelectedRegionArray;
                console.log('newSelectedRegionArray:', newSelectedRegionArray);
            }
        } else if (id.slice(0, 10) === 'groupModel') {
            fixedId = 'groupModel';
            if (checked) {
                let newGroupModelArray = [...inputData.groupModel];
                newGroupModelArray.push(value);
                fixedValue = newGroupModelArray;
            } else {
                let newGroupModelArray = inputData.groupModel.filter(element => element !== value);
                fixedValue = newGroupModelArray;
            }
        } else if (id.slice(0, 12) === 'activityType') {
            fixedId = 'activityType';
            if (checked) {
                let newActivityTypeArray = [...inputData.activityType];
                newActivityTypeArray.push(value);
                fixedValue = newActivityTypeArray;
            } else {
                let newActivityTypeArray = inputData.activityType.filter(element => element !== value);
                fixedValue = newActivityTypeArray;
            }
        } else if (id.slice(0, 8) === 'category') {
            fixedId = 'category';
            if (checked) {
                let newCategoryArray = [...inputData.category];
                newCategoryArray.push(value);
                fixedValue = newCategoryArray;
            } else {
                let newCategoryArray = inputData.category.filter(element => element !== value);
                fixedValue = newCategoryArray;
            }
        } else if (id.slice(0, 15) === 'difficultyLevel') {
            fixedId = 'difficultyLevel';
            if (checked) {
                let newDifficultyLevelArray = [...inputData.difficultyLevel];
                newDifficultyLevelArray.push(value);
                fixedValue = newDifficultyLevelArray;
            } else {
                let newDifficultyLevelArray = inputData.difficultyLevel.filter(element => element !== value);
                fixedValue = newDifficultyLevelArray;
            }
        } else if (id.slice(0, 15) === 'availablePeriod') {
            fixedId = 'availablePeriod';
            if (checked) {
                let newAvailablePeriodArray = [...inputData.availablePeriod];
                newAvailablePeriodArray.push(value);
                fixedValue = newAvailablePeriodArray;
            } else {
                let newAvailablePeriodArray = inputData.availablePeriod.filter(element => element !== value);
                fixedValue = newAvailablePeriodArray;
            }
        } else if (id === 'isActive') {
            fixedId = 'isActive';
            if (value === 'Bozza') {
                fixedValue = false
            } else {
                fixedValue = true
            }
        } else if (id === 'company') {
            fixedId = 'company';
            if (value === 'Nessuna') {
                fixedValue = null
            } else {
                fixedValue = value
            }
        } else if (id === 'isMonthAdviced') {
            fixedId = 'isMonthAdviced';
            fixedValue = checked ? true : false;
        } else if (id === 'isForInstagrammers') {
            fixedId = 'isForInstagrammers';
            fixedValue = checked ? true : false;
        } else if (id === 'isExternalPaid') {
            fixedId = 'isExternalPaid';
            fixedValue = checked ? true : false;
        } else {
            fixedId = id;
            fixedValue = value;
        }
        setInputData(prevState => ({
            ...prevState,
            [fixedId]: fixedValue
        }))
    }

    // Handle tag input
    const [tagInput, setTagInput] = useState(null);
    const handleTagInput = (event) => {
        const { value } = event.target
        setTagInput(value);
    }
    const addTagToInputData = () => {
        setInputData(prevState => ({
            ...prevState,
            tags: [...prevState.tags, tagInput]
        }))
        setTagInput(null)
    }
    const removeTagFromInputData = (string) => {
        const newTagsArray = inputData.tags.filter(element => element !== string);
        setInputData(prevState => ({
            ...prevState,
            tags: newTagsArray
        }))
    }

    // Handle priceInput
    const [priceInput, setPriceInput] = useState(null);
    const [peopleInput, setPeopleInput] = useState(null);
    const handlePriceInput = (event) => {
        setPriceInput(event.target.value);
    };
    const handlePeopleInput = (event) => {
        setPeopleInput(event.target.value);
    };

    const addPriceToInputData = () => {
        const fixedPrice = Number(priceInput);
        const fixedPeople = Number(peopleInput) === 0 ? 1 : Number(peopleInput);
        setInputData(prevState => ({
            ...prevState,
            price: [...prevState.price, { value: fixedPrice, people: fixedPeople }],
            isPremium: true
        }))
        setPriceInput(null);
        setPeopleInput(null);
    }
    const removePriceFromInputData = (value, people) => {
        const fixedValue = Number(value);
        const fixedPeople = Number(people);
        const newPriceArray = inputData.price.filter(element => element.value !== fixedValue || element.people !== fixedPeople);
        setInputData(prevState => ({
            ...prevState,
            price: newPriceArray
        }))
    }

    // Handle socialnetwork input
    const [socialInput, setSocialInput] = useState(null)
    const handleSocialInput = (event) => {
        const { value } = event.target;
        setSocialInput(value);
    }
    const addSocialToInputData = () => {
        setInputData(prevState => ({
            ...prevState,
            social: [...prevState.social, socialInput]
        }));
        setSocialInput(null)
    }
    const removeSocialFromInputata = (string) => {
        const newSocialArray = inputData.social.filter(element => element !== string);
        setInputData(prevState => ({
            ...prevState,
            social: newSocialArray
        }))
    }

    // Handle coordinates click
    const [clickCoordinates, setClickCoordinates] = useState(null);
    const [countryFetchStatus, setCountryFetchStatus] = useState('idle');
    const handleMapClick = (coordinates) => {
        setClickCoordinates(coordinates)
    }
    useEffect(() => {
        // Creo una funzione asincrona all'interno di useEffect per poter utilizzare il getcountry
        const setNewCoord = async () => {
            if (clickCoordinates) {
                // setCountryFetchStatus('loading'); GESTISCILO dentro la funzione
                setCountryFetchStatus('loading');
                let autoCountry = await getCountry(clickCoordinates.lat, clickCoordinates.lng);
                setInputData(prevState => ({
                    ...prevState,
                    coordinates: clickCoordinates,
                    autoCountry
                }))
                setCountryFetchStatus('idle');
            }
        }
        setNewCoord();
    }, [clickCoordinates])

    // Coordinates manual selection
    const [isManualSet, setIsManualSet] = useState({
        isManual: false,
        coo: null
    }) // questo stato booleano, da passare alla mappa, serve a modificare il marker 
    const [manualCoordinatesInput, setManualCoordinatesInput] = useState({
        manualLat: null,
        manualLng: null
    })
    useEffect(() => {
    }, [manualCoordinatesInput])
    // All'input delle coordinate manuali
    const handleManualCoordinatesInput = (event) => {
        const { id, value } = event.target;
        setManualCoordinatesInput(prevState => ({
            ...prevState,
            [id]: parseFloat(value)
        }))
    }

    // Al click del tasto 'Imposta'
    // Non imposta le coordinate direttamente, ma passa isManual alla mappa
    // in modo che lanci il flyTo e poi esegua il click
    const setNewCoordinates = async () => {
        let newCoordinates = {
            lat: manualCoordinatesInput.manualLat,
            lng: manualCoordinatesInput.manualLng
        };
        setCountryFetchStatus('loading');
        let autoCountry = await getCountry(newCoordinates.lat, newCoordinates.lng);
        setIsManualSet({
            isManual: true,
            coo: [newCoordinates.lat, newCoordinates.lng]
        })
        setCountryFetchStatus('idle');
        /* setManualCoordinatesInput({
            manualLat: null,
            manualLng: null
        }) */
    }

    //

    // Handle programInput
    const [programInput, setProgramInput] = useState(null);
    const handleProgramInput = (event) => {
        setProgramInput(event.target.value);
    }
    const addProgramToInputData = () => {
        setInputData(prevState => ({
            ...prevState,
            program: [...prevState.program, programInput]
        }))
        setProgramInput(null)
    }
    const removeProgramFromInputData = (string) => {
        setInputData(prevState => ({
            ...prevState,
            program: inputData.program.filter(element => element !== string)
        }))
    }

    // Handle servicesIncludedInput
    const [serviceIncludedInput, setServiceIncludedInput] = useState(null);
    const handleServiceIncludedInput = (event) => {
        setServiceIncludedInput(event.target.value);
    }
    const addServiceIncludedToInputData = () => {
        setInputData(prevState => ({
            ...prevState,
            servicesIncluded: [...prevState.servicesIncluded, serviceIncludedInput]
        }))
        setServiceIncludedInput(null)
    }
    const removeServiceIncludedFromInputData = (string) => {
        setInputData(prevState => ({
            ...prevState,
            servicesIncluded: inputData.servicesIncluded.filter(element => element !== string)
        }))
    }

    // Handle accessibilityInput
    const [accessibilityInput, setAccessibilityInput] = useState(null);
    const handleAccessibilityInput = (event) => {
        setAccessibilityInput(event.target.value);
    }
    const addAccessibilityToInputData = () => {
        setInputData(prevState => ({
            ...prevState,
            accessibility: [...prevState.accessibility, accessibilityInput]
        }))
        setAccessibilityInput(null)
    }
    const removeAccessibilityFromInputData = (string) => {
        setInputData(prevState => ({
            ...prevState,
            accessibility: inputData.accessibility.filter(element => element !== string)
        }))
    }

    // Handle cancellationInput
    const [cancellationInput, setCancellationInput] = useState(null);
    const handleCancellationInput = (event) => {
        setCancellationInput(event.target.value);
    }
    const addCancellationToInputData = () => {
        setInputData(prevState => ({
            ...prevState,
            cancellation: [...prevState.cancellation, cancellationInput]
        }))
        setCancellationInput(null)
    }
    const removeCancellationFromInputData = (string) => {
        setInputData(prevState => ({
            ...prevState,
            cancellation: inputData.cancellation.filter(element => element !== string)
        }))
    }

    // Handle rentInput
    const [rentInput, setRentInput] = useState(null);
    const handleRentInput = (event) => {
        setRentInput(event.target.value);
    }
    const addRentToInputData = () => {
        setInputData(prevState => ({
            ...prevState,
            equipmentRentInfo: [...prevState.equipmentRentInfo, rentInput]
        }))
        setRentInput(null)
    }
    const removeRentFromInputData = (string) => {
        setInputData(prevState => ({
            ...prevState,
            equipmentRentInfo: inputData.equipmentRentInfo.filter(element => element !== string)
        }))
    }

    // Handle precautionsInput
    const [precautionsInput, setPrecautionsInput] = useState(null);
    const handlePrecautionsInput = (event) => {
        setPrecautionsInput(event.target.value);
    }
    const addPrecautionToInputData = () => {
        setInputData(prevState => ({
            ...prevState,
            precautions: [...prevState.precautions, precautionsInput]
        }))
        setPrecautionsInput(null)
    }
    const removePrecautionFromInputData = (string) => {
        setInputData(prevState => ({
            ...prevState,
            precautions: inputData.precautions.filter(element => element !== string)
        }))
    }

    // Handle onsiteEquipmentInput
    const [onsiteEquipmentInput, setOnsiteEquipmentInput] = useState(null);
    const handleOnsiteEquipmentInput = (event) => {
        setOnsiteEquipmentInput(event.target.value);
    }
    const addOnsiteEquipmentToInputData = () => {
        setInputData(prevState => ({
            ...prevState,
            onsiteEquipment: [...prevState.onsiteEquipment, onsiteEquipmentInput]
        }))
        setOnsiteEquipmentInput(null)
    }
    const removeOnsiteEquipmentToInputData = (string) => {
        setInputData(prevState => ({
            ...prevState,
            onsiteEquipment: inputData.onsiteEquipment.filter(element => element !== string)
        }))
    }

    // Handle technicalInput
    const [technicalInput, setTechnicalInput] = useState(null);
    const handleTechnicalInput = (event) => {
        setTechnicalInput(event.target.value);
    }
    const addTechnicalToInputData = () => {
        setInputData(prevState => ({
            ...prevState,
            technical: [...prevState.technical, technicalInput]
        }))
        setTechnicalInput(null)
    }
    const removeTechnicalFromInputData = (string) => {
        setInputData(prevState => ({
            ...prevState,
            technical: inputData.technical.filter(element => element !== string)
        }))
    }

    // Handle difficulty
    const [difficultyInput, setDifficultyInput] = useState(null);
    const handleDifficultyInput = (event) => {
        setDifficultyInput(event.target.value);
    }
    const addDifficultyToInputData = () => {
        setInputData(prevState => ({
            ...prevState,
            difficultyLevel: [...prevState.difficultyLevel, difficultyInput]
        }))
        setDifficultyInput(null)
    }
    const removeDifficultyFromInputData = (string) => {
        setInputData(prevState => ({
            ...prevState,
            difficultyLevel: inputData.difficultyLevel.filter(element => element !== string)
        }))
    }

    // Handle addCategoryInput
    const [addCategoryInput, setAddCategoryInput] = useState(null);
    const handleAddCategoryInput = (event) => {
        setAddCategoryInput(event.target.value);
    }
    const addCategoryToInputData = () => {
        setInputData(prevState => ({
            ...prevState,
            category: [...prevState.category, addCategoryInput]
        }))
        setAddCategoryInput(null)
    }
    const removeCategoryFromInputData = (string) => {
        setInputData(prevState => ({
            ...prevState,
            category: inputData.category.filter(element => element !== string)
        }))
    }

    // Handle details section
    const [isOtherOptionsOpen, setIsOtherOptionsOpen] = useState(false);

    // Send data fetch
    const [fetchStatus, setFetchStatus] = useState('idle');
    const [fetchError, setFetchError] = useState(null);
    const navigate = useNavigate();
    const sendData = async () => {
        setFetchStatus('loading')
        const token = localStorage.getItem('ticino-wild-token');
        const url = isEditMode ? `${process.env.REACT_APP_SERVER_BASE_URL}/activities/edit-activity` : `${process.env.REACT_APP_SERVER_BASE_URL}/activities/add-new`;
        const headers = {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${token}`
        };
        const options = {
            method: isEditMode ? 'PATCH' : 'POST',
            headers,
            body: JSON.stringify(inputData)
        }
        try {
            const response = await fetch(url, options);
            if (response.ok) {
                const result = await response.json();
                setFetchStatus('succeeded');
                setTimeout(() => {
                    dispatch(setIsNeedHomeRefresh(true));
                    dispatch(setIsNeedRefresh(true));
                    window.scrollTo(0, 0);
                    navigate("/handle-activities");
                }, 2000)
            } else {
                const error = await response.json();
                setFetchError(error);
                setFetchStatus('failed');
            }
        } catch (error) {
            setFetchError(error);
            setFetchStatus('failed');
        }
    }

    // Gestisco UX campi obbligatori
    // Imposto isPremium su false se il price è vuoto
    const [isFieldsError, setIsFieldsError] = useState(false);
    const [fieldsChecked, setFieldsChecked] = useState(false);
    useEffect(() => {
        // Setto isPremium false
        if (inputData.price.length === 0 && inputData.isPremium) {
            setInputData(prevState => ({
                ...prevState,
                isPremium: false
            }))
        };
        // Controllo i campi obbligatori
        let requiredFields = {};
        inputData.activityType ? requiredFields.activityType = true : requiredFields.activityType = false;
        inputData.category ? requiredFields.category = true : requiredFields.category = false;
        inputData.selectedRegion ? requiredFields.selectedRegion = true : requiredFields.selectedRegion = false;
        inputData.title ? requiredFields.title = true : requiredFields.title = false;
        inputData.description ? requiredFields.description = true : requiredFields.description = false;
        inputData.coordinates ? requiredFields.coordinates = true : requiredFields.coordinates = false;
        let allFieldsAreTrue = Object.values(requiredFields).every(Boolean);
        allFieldsAreTrue ? setFieldsChecked(true) : setFieldsChecked(false);
    }, [inputData]);
    const handleCheckFieldsAndSendData = () => {
        fieldsChecked ? sendData() : setIsFieldsError(true);
    };
    useEffect(() => {
        setTimeout(() => {
            setIsFieldsError(false);
        }, 3000);
    }, [isFieldsError])

    // Gestisco la selezione dell'immagine di copertina
    const handleSelectCover = (index) => {
        let newCoverImage = { ...inputData.gallery[index] };
        if (inputData.coverImageUrl) {
            if (newCoverImage.public_id === inputData.coverImageUrl.public_id) {
                setInputData(prevState => ({
                    ...prevState,
                    coverImageUrl: null
                }))
            } else {
                setInputData(prevState => ({
                    ...prevState,
                    coverImageUrl: newCoverImage
                }))
            }
        } else {
            setInputData(prevState => ({
                ...prevState,
                coverImageUrl: newCoverImage
            }))
        }
    }

    // Gestisco la selezione dell'azienda
    const companiesData = useSelector(state => state.adminCompanies.data);
    // Eseguo la chiamata se data è null
    useEffect(() => {
        if (!companiesData) {
            dispatch(getAllCompanies())
        }
    }, [companiesData])

    return (
        <PageContainer px="4" desktopItems="center" isRelative>
            <PageTitle title={!isEditMode ? "Aggiungi attività" : "Modifica attività"} backLink="/handle-activities" />

            {/*  Loader con overlay nel caso in modalità edit si refreshi */}
            {
                isLoading &&
                <div className="absolute inset-0 z-10 bg-[#f7f7f8] bg-opacity-90">
                    <div className="w-full flex justify-center mt-24">
                        <Loader />
                    </div>
                </div>
            }

            {/* Gestisci lingua */}
            {
                isEditMode &&
                <GreenButton text="Gestisci le traduzioni" link={`/handle-activity-translation?activityId=${activityId}`} />
            }
            {
                !isEditMode &&
                <p className="text-xs italic text-[#225424]">(Le traduzioni potranno essere impostate dopo aver salvato la nuova attività)</p>
            }

            {/* Macro categoria */}
            <h2 className="mt-8">Categoria attività</h2>
            <CustomHr />

            <div className="flex flex-col p-2 gap-2 w-full lg:w-[800px]">
                <label htmlFor="activityType">Genere</label>
                <div className="w-full lg:w-[800px] flex flex-col gap-2">
                    <div className={`border-2 rounded p-2 ${inputData.activityType.includes('Acqua') ? 'border-[#225424]' : ''}`}><input className="mr-2" onChange={handleInputData} type="checkbox" value="Acqua" id="activityType1" checked={inputData.activityType.includes('Acqua') ? true : false} /> <i className="fi fi-ss-raindrops"></i> <label>Acqua</label></div>
                    <div className={`border-2 rounded p-2 ${inputData.activityType.includes('Aria') ? 'border-[#225424]' : ''}`}><input className="mr-2" onChange={handleInputData} type="checkbox" value="Aria" id="activityType2" checked={inputData.activityType.includes('Aria') ? true : false} /> <i className="fi fi-ss-smoke"></i> <label>Aria</label></div>
                    <div className={`border-2 rounded p-2 ${inputData.activityType.includes('Terra') ? 'border-[#225424]' : ''}`}><input className="mr-2" onChange={handleInputData} type="checkbox" value="Terra" id="activityType3" checked={inputData.activityType.includes('Terra') ? true : false} /> <i className="fi fi-sr-mound"></i> <label>Terra</label></div>
                    <div className={`border-2 rounded p-2 ${inputData.activityType.includes('Neve') ? 'border-[#225424]' : ''}`}><input className="mr-2" onChange={handleInputData} type="checkbox" value="Neve" id="activityType4" checked={inputData.activityType.includes('Neve') ? true : false} /> <i className="fi fi-rr-snowflakes"></i> <label>Neve</label></div>
                    <div className={`border-2 rounded p-2 ${inputData.activityType.includes('Best Views') ? 'border-[#225424]' : ''}`}><input className="mr-2" onChange={handleInputData} type="checkbox" value="Best Views" id="activityType5" checked={inputData.activityType.includes('Best Views') ? true : false} /> <i className="fi fi-sr-mountains"></i> <label>Best Views</label></div>
                </div>
            </div>


            {/* Categoria attività */}
            <div className="flex flex-col p-2 gap-2 w-full lg:w-[800px]">
                <label htmlFor="category">Categoria</label>
                <div className="flex w-full flex-col lg:flex-row gap-2">
                    <div className="flex-1 flex flex-col gap-2">
                        <h5>Acqua</h5>
                        {
                            <CheckboxList stringList={waterCategories} inputDataKey="category" inputDataValue={inputData.category} returnFunction={handleInputData} />
                        }
                    </div>
                    <div className="flex-1 flex flex-col gap-2">
                        <h5>Aria</h5>
                        {
                            <CheckboxList stringList={airCategories} inputDataKey="category" inputDataValue={inputData.category} returnFunction={handleInputData} />
                        }
                    </div>
                    <div className="flex-1 flex flex-col gap-2">
                        <h5>Terra</h5>
                        {
                            <CheckboxList stringList={landCategories} inputDataKey="category" inputDataValue={inputData.category} returnFunction={handleInputData} />
                        }
                    </div>
                    <div className="flex-1 flex flex-col gap-2">
                        <h5>Neve</h5>
                        {
                            <CheckboxList stringList={snowCategories} inputDataKey="category" inputDataValue={inputData.category} returnFunction={handleInputData} />
                        }
                    </div>
                    <div className="flex-1 flex flex-col gap-2">
                        <h5>Best Views</h5>
                        {
                            <CheckboxList stringList={bestViewsCategories} inputDataKey="category" inputDataValue={inputData.category} returnFunction={handleInputData} />
                        }
                    </div>
                </div>
            </div>

            {/* Regione */}
            <div className="flex flex-col p-2 gap-2 w-full lg:w-[800px]">
                <label htmlFor="activityType">Regione</label>
                <div className="w-full lg:w-[800px] flex flex-col gap-2">
                    <div className={`border-2 rounded p-2 ${inputData.selectedRegion.includes('Bellinzona e Valli') ? 'border-[#225424]' : ''}`}><input className="mr-2" onChange={handleInputData} type="checkbox" value="Bellinzona e Valli" id="selectedRegion1" checked={inputData.selectedRegion.includes('Bellinzona e Valli') ? true : false} /><label>Bellinzona e Valli</label></div>
                    <div className={`border-2 rounded p-2 ${inputData.selectedRegion.includes('Luganese') ? 'border-[#225424]' : ''}`}><input className="mr-2" onChange={handleInputData} type="checkbox" value="Luganese" id="selectedRegion2" checked={inputData.selectedRegion.includes('Luganese') ? true : false} /><label>Luganese</label></div>
                    <div className={`border-2 rounded p-2 ${inputData.selectedRegion.includes('Mendrisiotto') ? 'border-[#225424]' : ''}`}><input className="mr-2" onChange={handleInputData} type="checkbox" value="Mendrisiotto" id="selectedRegion3" checked={inputData.selectedRegion.includes('Mendrisiotto') ? true : false} /><label>Mendrisiotto</label></div>
                    <div className={`border-2 rounded p-2 ${inputData.selectedRegion.includes('Ascona-Locarno') ? 'border-[#225424]' : ''}`}><input className="mr-2" onChange={handleInputData} type="checkbox" value="Ascona-Locarno" id="selectedRegion14" checked={inputData.selectedRegion.includes('Ascona-Locarno') ? true : false} /><label>Ascona-Locarno</label></div>
                </div>
            </div>

            {/* Informazioni generali */}
            <h2 className="mt-8">Informazioni generali</h2>
            <CustomHr />

            <div className="flex flex-col p-2 gap-2 w-full lg:w-fit">
                <label htmlFor="title">Titolo <span className="text-xl">*</span></label>
                <input type="text" id="title" placeholder="Titolo dell'attività" className="lg:w-[800px]" onChange={handleInputData} value={inputData.title ? inputData.title : null} />
            </div>
            <div className="flex flex-col p-2 gap-2 w-full lg:w-fit">
                <label htmlFor="summary">Sommario</label>
                <input type="text" id="summary" placeholder="Riassumi l'attività" className="lg:w-[800px]" onChange={handleInputData} value={inputData.summary ? inputData.summary : null} />
            </div>
            {/* <div className="flex flex-col p-2 gap-2 w-full lg:w-fit">
                <label htmlFor="description">Descrizione <span className="text-xl">*</span></label>
                <textarea id="description" className="resize-none lg:w-[800px]" onChange={handleInputData} value={inputData.description ? inputData.description : null} />
            </div> */}
            <div className="flex flex-col p-2 gap-2 w-full lg:w-[800px]">
                <label htmlFor="description">Descrizione <span className="text-xl">*</span></label>
                <QuillTextarea setInputData={setInputData} initContent={inputData.description} />
            </div>

            {/* Tags */}
            <div className="flex flex-col p-2 gap-2 w-full lg:w-[800px]">
                <label htmlFor="description">Tag</label>
                <div className="flex gap-2 max-w-[800px] lg:w-[800px]">
                    <input type="text" className="flex-grow" onChange={handleTagInput} value={tagInput ? tagInput : ''} />
                    {tagInput && <button className="w-[72px] h-[72px] rounded-lg border-2 border-[#225424] text-[#225424] flex justify-center items-center text-4xl pb-1" onClick={addTagToInputData}>+</button>}
                    {!tagInput && <button className="w-[72px] h-[72px] rounded-lg border-2 border-neutral-300 text-neutral-300 flex justify-center items-center text-4xl pb-1 cursor-not-allowed">+</button>}
                </div>
                <div className="border-2 p-2 flex gap-2 flex-wrap min-h-[72px] w-full">
                    {
                        inputData && inputData.tags.length > 0 && inputData.tags.map((element, index) => {
                            return <TagLabel key={index} tag={element} close={removeTagFromInputData} />
                        })
                    }
                </div>
            </div>

            {/* Modelli di gruppo */}
            <h2 className="mt-8">Modello di gruppo</h2>
            <CustomHr />
            <div className="w-full lg:w-[800px] flex flex-col gap-2">
                <div className={`border-2 rounded p-2 ${inputData.groupModel.includes('Da soli') ? 'border-[#225424]' : ''}`}><input className="mr-2" onChange={handleInputData} type="checkbox" value="Da soli" id="groupModel1" checked={inputData.groupModel.includes('Da soli') ? true : false} /> <i className="fi fi-sr-user"></i> <label>Da soli</label></div>
                <div className={`border-2 rounded p-2 ${inputData.groupModel.includes('In coppia') ? 'border-[#225424]' : ''}`}><input className="mr-2" onChange={handleInputData} type="checkbox" value="In coppia" id="groupModel2" checked={inputData.groupModel.includes('In coppia') ? true : false} /> <i className="fi fi-sr-users"></i> <label>In coppia</label></div>
                <div className={`border-2 rounded p-2 ${inputData.groupModel.includes('Fra amici') ? 'border-[#225424]' : ''}`}><input className="mr-2" onChange={handleInputData} type="checkbox" value="Fra amici" id="groupModel3" checked={inputData.groupModel.includes('Fra amici') ? true : false} /> <i className="fi fi-sr-users-alt"></i> <label>Fra amici</label></div>
                <div className={`border-2 rounded p-2 ${inputData.groupModel.includes('In famiglia') ? 'border-[#225424]' : ''}`}><input className="mr-2" onChange={handleInputData} type="checkbox" value="In famiglia" id="groupModel4" checked={inputData.groupModel.includes('In famiglia') ? true : false} /> <i className="fi fi-sr-family"></i> <label>In famiglia</label></div>
                <div className={`border-2 rounded p-2 ${inputData.groupModel.includes('Per bambini') ? 'border-[#225424]' : ''}`}><input className="mr-2" onChange={handleInputData} type="checkbox" value="Per bambini" id="groupModel5" checked={inputData.groupModel.includes('Per bambini') ? true : false} /> <i className="fi fi-sr-child-head"></i> <label>Per bambini</label></div>
            </div>

            {/* Livello di difficoltà */}
            <h2 className="mt-8">Livello di difficoltà</h2>
            <CustomHr />
            <div className="w-full lg:w-[800px] flex flex-col gap-2">
                <div className={`border-2 rounded p-2 ${inputData.difficultyLevel.includes('Facile') ? 'border-[#225424]' : ''}`}><input className="mr-2" onChange={handleInputData} type="checkbox" value="Facile" id="difficultyLevel1" checked={inputData.difficultyLevel.includes('Facile') ? true : false} /><label>Facile</label></div>
                <div className={`border-2 rounded p-2 ${inputData.difficultyLevel.includes('Medio') ? 'border-[#225424]' : ''}`}><input className="mr-2" onChange={handleInputData} type="checkbox" value="Medio" id="difficultyLevel2" checked={inputData.difficultyLevel.includes('Medio') ? true : false} /><label>Medio</label></div>
                <div className={`border-2 rounded p-2 ${inputData.difficultyLevel.includes('Difficile') ? 'border-[#225424]' : ''}`}><input className="mr-2" onChange={handleInputData} type="checkbox" value="Difficile" id="difficultyLevel3" checked={inputData.difficultyLevel.includes('Difficile') ? true : false} /><label>Difficile</label></div>
            </div>


            {/* Periodo dell'anno */}
            <h2 className="mt-8">Periodo dell'anno</h2>
            <CustomHr />
            <div className="w-full lg:w-[800px] flex flex-col gap-2">
                <div className={`border-2 rounded p-2 ${inputData.availablePeriod.includes('Gennaio') ? 'border-[#225424]' : ''}`}><input className="mr-2" onChange={handleInputData} type="checkbox" value="Gennaio" id="availablePeriod1" checked={inputData.availablePeriod.includes('Gennaio') ? true : false} /><label>Gennaio</label></div>
                <div className={`border-2 rounded p-2 ${inputData.availablePeriod.includes('Febbraio') ? 'border-[#225424]' : ''}`}><input className="mr-2" onChange={handleInputData} type="checkbox" value="Febbraio" id="availablePeriod2" checked={inputData.availablePeriod.includes('Febbraio') ? true : false} /><label>Febbraio</label></div>
                <div className={`border-2 rounded p-2 ${inputData.availablePeriod.includes('Marzo') ? 'border-[#225424]' : ''}`}><input className="mr-2" onChange={handleInputData} type="checkbox" value="Marzo" id="availablePeriod3" checked={inputData.availablePeriod.includes('Marzo') ? true : false} /><label>Marzo</label></div>
                <div className={`border-2 rounded p-2 ${inputData.availablePeriod.includes('Aprile') ? 'border-[#225424]' : ''}`}><input className="mr-2" onChange={handleInputData} type="checkbox" value="Aprile" id="availablePeriod4" checked={inputData.availablePeriod.includes('Aprile') ? true : false} /><label>Aprile</label></div>
                <div className={`border-2 rounded p-2 ${inputData.availablePeriod.includes('Maggio') ? 'border-[#225424]' : ''}`}><input className="mr-2" onChange={handleInputData} type="checkbox" value="Maggio" id="availablePeriod5" checked={inputData.availablePeriod.includes('Maggio') ? true : false} /><label>Maggio</label></div>
                <div className={`border-2 rounded p-2 ${inputData.availablePeriod.includes('Giugno') ? 'border-[#225424]' : ''}`}><input className="mr-2" onChange={handleInputData} type="checkbox" value="Giugno" id="availablePeriod6" checked={inputData.availablePeriod.includes('Giugno') ? true : false} /><label>Giugno</label></div>
                <div className={`border-2 rounded p-2 ${inputData.availablePeriod.includes('Luglio') ? 'border-[#225424]' : ''}`}><input className="mr-2" onChange={handleInputData} type="checkbox" value="Luglio" id="availablePeriod7" checked={inputData.availablePeriod.includes('Luglio') ? true : false} /><label>Luglio</label></div>
                <div className={`border-2 rounded p-2 ${inputData.availablePeriod.includes('Agosto') ? 'border-[#225424]' : ''}`}><input className="mr-2" onChange={handleInputData} type="checkbox" value="Agosto" id="availablePeriod8" checked={inputData.availablePeriod.includes('Agosto') ? true : false} /><label>Agosto</label></div>
                <div className={`border-2 rounded p-2 ${inputData.availablePeriod.includes('Settembre') ? 'border-[#225424]' : ''}`}><input className="mr-2" onChange={handleInputData} type="checkbox" value="Settembre" id="availablePeriod9" checked={inputData.availablePeriod.includes('Settembre') ? true : false} /><label>Settembre</label></div>
                <div className={`border-2 rounded p-2 ${inputData.availablePeriod.includes('Ottobre') ? 'border-[#225424]' : ''}`}><input className="mr-2" onChange={handleInputData} type="checkbox" value="Ottobre" id="availablePeriod10" checked={inputData.availablePeriod.includes('Ottobre') ? true : false} /><label>Ottobre</label></div>
                <div className={`border-2 rounded p-2 ${inputData.availablePeriod.includes('Novembre') ? 'border-[#225424]' : ''}`}><input className="mr-2" onChange={handleInputData} type="checkbox" value="Novembre" id="availablePeriod11" checked={inputData.availablePeriod.includes('Novembre') ? true : false} /><label>Novembre</label></div>
                <div className={`border-2 rounded p-2 ${inputData.availablePeriod.includes('Dicembre') ? 'border-[#225424]' : ''}`}><input className="mr-2" onChange={handleInputData} type="checkbox" value="Dicembre" id="availablePeriod12" checked={inputData.availablePeriod.includes('Dicembre') ? true : false} /><label>Dicembre</label></div>
            </div>

            {/* Prezzo */}
            <h2 className="mt-8">Prezzo</h2>
            <CustomHr />

            <div className="flex flex-col p-2 gap-2 w-full lg:w-fit">
                <div className="flex flex-col md:flex-row items-center gap-2 p-2 border-2">
                    <label htmlFor="price">Prezzo</label>
                    <div className="flex gap-2">
                        <input type="number" min="0" className="flex-grow" onChange={handlePriceInput} value={priceInput ? priceInput : ''} />
                    </div>
                    <label htmlFor="price">Persone</label>
                    <div className="flex gap-2">
                        <input type="number" min="0" className="flex-grow" onChange={handlePeopleInput} value={peopleInput ? peopleInput : ''} />
                        {priceInput && <button className="w-[72px] h-[72px] rounded-lg border-2 border-[#225424] text-[#225424] flex justify-center items-center text-4xl pb-1" onClick={addPriceToInputData}>+</button>}
                        {!priceInput && <button className="w-[72px] h-[72px] rounded-lg border-2 border-neutral-300 text-neutral-300 flex justify-center items-center text-4xl pb-1 cursor-not-allowed">+</button>}
                    </div>
                </div>
                <div className="border-2 p-2 flex flex-col gap-2 min-h-[72px] rounded">
                    {
                        inputData && inputData.price && inputData.price.length > 0 && inputData.price.map((element, index) => {
                            return <div key={index} className="border-2 border-[#225424] text-black py-2 px-3 rounded-lg flex items-center justify-between gap-2 text-lg w-full">{getPriceString(element.value, element.people)} <div className="pt-2"><i className="fi fi-sr-circle-xmark text-xl cursor-pointer" onClick={() => removePriceFromInputData(element.value, element.people)}></i></div></div>
                        })
                    }
                </div>
                <div className="flex flex-col gap-2 mt-8">
                    <label htmlFor="priceNote">Note sul prezzo</label>
                    <textarea id="priceNote" onChange={handleInputData} value={inputData.priceNote ? inputData.priceNote : ''}></textarea>
                </div>
            </div>

            {/* Contatti */}
            <h2 className="mt-8">Contatti</h2>
            <CustomHr />

            <div className="flex flex-col p-2 gap-2 w-full lg:w-fit">
                <label htmlFor="email">Email</label>
                <input type="text" id="email" placeholder="mario.rossi@gmail.com" className="lg:w-[800px]" onChange={handleInputData} value={inputData.email ? inputData.email : ''} />
            </div>
            <div className="flex flex-col p-2 gap-2 w-full lg:w-fit">
                <label htmlFor="website">Website</label>
                <input type="text" id="website" placeholder="www.mariorossi.ch" className="lg:w-[800px]" onChange={handleInputData} value={inputData.website ? inputData.website : ''} />
            </div>

            {/* Social Network */}
            <h2 className="mt-8">Social Network</h2>
            <CustomHr />

            <div className="flex flex-col p-2 gap-2 w-full lg:w-fit">
                <label htmlFor="description">Social Network</label>
                <div className="flex gap-2 max-w-[800px] lg:w-[800px]">
                    <input type="text" className="flex-grow" onChange={handleSocialInput} value={socialInput ? socialInput : ''} />
                    {socialInput && <button className="w-[72px] h-[72px] rounded-lg border-2 border-[#225424] text-[#225424] flex justify-center items-center text-4xl pb-1" onClick={addSocialToInputData}>+</button>}
                    {!socialInput && <button className="w-[72px] h-[72px] rounded-lg border-2 border-neutral-300 text-neutral-300 flex justify-center items-center text-4xl pb-1 cursor-not-allowed">+</button>}
                </div>
                <div className="border-2 p-2 flex gap-2 flex-wrap min-h-[72px]">
                    {
                        inputData && inputData.social.length > 0 && inputData.social.map((element, index) => {
                            return <ElementLabel key={index} string={element} close={removeSocialFromInputata} />
                        })
                    }
                </div>
            </div>

            {/* Location */}
            <h2 className="mt-8">Location</h2>
            <CustomHr />

            <h4>Clicca sulla mappa per definire le coordinate <span className="text-xl">*</span></h4>
            <div className="flex flex-col p-4 gap-2 w-full lg:w-fit border-2 rounded">
                <div className="mb-[-35px] self-end"><ToFixMessage message="Fixare zoom automatico e refresh al click" /></div>
                <ActivityLocationMap onMapClick={handleMapClick} canton={inputData.canton ? inputData.canton : null} coordinates={inputData.coordinates ? [inputData.coordinates.lat, inputData.coordinates.lng] : null} isManualSet={isManualSet} setIsManualSet={setIsManualSet} />
                {
                    inputData.coordinates && countryFetchStatus === 'idle' &&
                    <div className="flex flex-col gap-2">
                        <div className="flex flex-col p-2 border-2 border-[#225424] rounded bg-# w-full lg:w-fit">
                            Coordinate: {inputData.coordinates.lat}, {inputData.coordinates.lng}
                        </div>
                        <div className="flex flex-col p-2 border-2 border-[#225424] rounded bg-# w-full lg:w-fit">
                            Paese/Regione: {inputData.autoCountry}
                        </div>
                    </div>
                }
                {countryFetchStatus === 'loading' && <Loader />}
            </div>

            {/* Coordinate manuali */}
            <p className="mt-8">oppure</p>
            <h4 className="mt-8">Inserisci le coordinate manualmente <span className="text-xl">*</span></h4>
            <div className="flex flex-col gap-2 p-4 border-2 rounded w-full lg:w-fit">
                <div className="flex flex-col lg:flex-row gap-2">
                    <div className="flex gap-2 items-center">
                        <label htmlFor="">Latitudine:</label>
                        <input type="number" id="manualLat" className="w-full" onChange={handleManualCoordinatesInput} value={manualCoordinatesInput.manualLat ? manualCoordinatesInput.manualLat : ''} />
                    </div>
                    <div className="flex gap-2 items-center">
                        <label htmlFor="">Longitudine:</label>
                        <input type="number" id="manualLng" className="w-full" onChange={handleManualCoordinatesInput} value={manualCoordinatesInput.manualLng ? manualCoordinatesInput.manualLng : ''} />
                    </div>
                    {manualCoordinatesInput.manualLat && manualCoordinatesInput.manualLng && <GreenButton text="Imposta" isMobileFull click={setNewCoordinates} />}
                </div>
            </div>


            {/* FOTO */}
            <h2 className="mt-8">Aggiungi foto</h2>
            <CustomHr />

            <UploadPhotos inputDataGallery={inputData.gallery} setInputData={setInputData} coverPublicId={inputData.coverImageUrl ? inputData.coverImageUrl.public_id : null} handleSelectCover={handleSelectCover} type="Activity" />

            {/* Servizi aggiuntivi */}
            <h2 className="mt-8">Servizi aggiuntivi</h2>

            <CustomHr />
            <div className="w-full lg:w-[800px] flex flex-col gap-2">
                <div className={`border-2 rounded p-2 ${inputData.details.includes('Parcheggio') ? 'border-[#225424]' : ''}`}><input className="mr-2" onChange={handleInputData} type="checkbox" value="Parcheggio" id="details1" checked={inputData.details.includes('Parcheggio') ? true : false} /> <i className="fi fi-rr-parking-circle"></i> <label>Parcheggio</label></div>
                <div className={`border-2 rounded p-2 ${inputData.details.includes('Ricarica veicoli elettrici') ? 'border-[#225424]' : ''}`}><input className="mr-2" onChange={handleInputData} type="checkbox" value="Ricarica veicoli elettrici" id="details2" checked={inputData.details.includes('Ricarica veicoli elettrici') ? true : false} /> <i className="fi fi-rr-charging-station"></i> <label>Ricarica veicoli elettrici</label></div>
                <div className={`border-2 rounded p-2 ${inputData.details.includes('Trasporti pubblici nelle vicinanze') ? 'border-[#225424]' : ''}`}><input className="mr-2" onChange={handleInputData} type="checkbox" value="Trasporti pubblici nelle vicinanze" id="details3" checked={inputData.details.includes('Trasporti pubblici nelle vicinanze') ? true : false} /> <i className="fi fi-rr-car-bus"></i> <label>Trasporti pubblici nelle vicinanze</label></div>
                <div className={`border-2 rounded p-2 ${inputData.details.includes('WC') ? 'border-[#225424]' : ''}`}><input className="mr-2" onChange={handleInputData} type="checkbox" value="WC" id="details4" checked={inputData.details.includes('WC') ? true : false} /> <i className="fi fi-rr-toilet"></i> <label>WC</label></div>
                <div className={`border-2 rounded p-2 ${inputData.details.includes('Docce/Spogliatoi') ? 'border-[#225424]' : ''}`}><input className="mr-2" onChange={handleInputData} type="checkbox" value="Docce/Spogliatoi" id="details5" checked={inputData.details.includes('Docce/Spogliatoi') ? true : false} /> <i className="fi fi-rr-shower"></i> <label>Docce/Spogliatoi</label></div>
                <div className={`border-2 rounded p-2 ${inputData.details.includes('Armadietti con chiave') ? 'border-[#225424]' : ''}`}><input className="mr-2" onChange={handleInputData} type="checkbox" value="Armadietti con chiave" id="details6" checked={inputData.details.includes('Armadietti con chiave') ? true : false} /> <i className="fi fi-rr-unlock"></i> <label>Armadietti con chiave</label></div>
                <div className={`border-2 rounded p-2 ${inputData.details.includes('Punto ristoro') ? 'border-[#225424]' : ''}`}><input className="mr-2" onChange={handleInputData} type="checkbox" value="Punto ristoro" id="details7" checked={inputData.details.includes('Punto ristoro') ? true : false} /> <i className="fi fi-rr-utensils"></i> <label>Punto ristoro</label></div>
                <div className={`border-2 rounded p-2 ${inputData.details.includes('Area picnic') ? 'border-[#225424]' : ''}`}><input className="mr-2" onChange={handleInputData} type="checkbox" value="Area picnic" id="details8" checked={inputData.details.includes('Area picnic') ? true : false} /> <i className="fi fi-rr-table-picnic"></i> <label>Area picnic</label></div>
                <div className={`border-2 rounded p-2 ${inputData.details.includes('Noleggio attrezzatura') ? 'border-[#225424]' : ''}`}><input className="mr-2" onChange={handleInputData} type="checkbox" value="Noleggio attrezzatura" id="details10" checked={inputData.details.includes('Noleggio attrezzatura') ? true : false} /> <i className="fi fi-rr-hiking"></i> <label>Noleggio attrezzatura</label></div>
                <div className={`border-2 rounded p-2 ${inputData.details.includes('Gruppo minimo di partecipanti') ? 'border-[#225424]' : ''}`}><input className="mr-2" onChange={handleInputData} type="checkbox" value="Gruppo minimo di partecipanti" id="details9" checked={inputData.details.includes('Gruppo minimo di partecipanti') ? true : false} /> <i className="fi fi-rr-users"></i> <label>Gruppo minimo di partecipanti</label></div>
            </div>

            {/* Numero minimo partecipanti */}
            {
                inputData.details.includes('Gruppo minimo di partecipanti') &&
                <div className="w-full lg:w-[800px] mt-4">
                    <label htmlFor="minimumGroup">A partire da: </label>
                    <input type="number" id="minimumGroup" className="w-20" value={inputData.minimumGroup ? inputData.minimumGroup : ''} onChange={handleInputData} />
                    <label htmlFor=""> partecipanti</label>
                </div>
            }

            {/* Età minima */}
            <h2 className="mt-8">Età minima</h2>
            <CustomHr />
            <div className="lg:w-[800px]">
                <label htmlFor="recommendedAge">A partire da: </label>
                <input type="number" id="recommendedAge" className="w-20" value={inputData.recommendedAge ? inputData.recommendedAge : ''} onChange={handleInputData} />
                <label htmlFor=""> anni</label>
            </div>

            {/* Lingue disponibili */}
            <h2 className="mt-8">Lingue disponibili</h2>
            <CustomHr />
            <div className="w-full lg:w-[800px] flex flex-col gap-2">
                <div className={`border-2 rounded p-2 ${inputData.languages.includes('Italian') ? 'border-[#225424]' : ''}`}><input type="checkbox" onChange={handleInputData} id="languages1" value="Italian" checked={inputData.languages.includes('Italian') ? true : false} /> <label>Italiano</label></div>
                <div className={`border-2 rounded p-2 ${inputData.languages.includes('English') ? 'border-[#225424]' : ''}`}><input type="checkbox" onChange={handleInputData} id="languages2" value="English" checked={inputData.languages.includes('English') ? true : false} /> <label>Inglese</label></div>
                <div className={`border-2 rounded p-2 ${inputData.languages.includes('German') ? 'border-[#225424]' : ''}`}><input type="checkbox" onChange={handleInputData} id="languages3" value="German" checked={inputData.languages.includes('German') ? true : false} /> <label>Tedesco</label></div>
                <div className={`border-2 rounded p-2 ${inputData.languages.includes('French') ? 'border-[#225424]' : ''}`}><input type="checkbox" onChange={handleInputData} id="languages4" value="French" checked={inputData.languages.includes('French') ? true : false} /> <label>Francese</label></div>
            </div>

            {/* Altre opzioni */}
            <div className="flex gap-2 mt-8">
                <div><h2>Altre opzioni</h2></div>
                {isOtherOptionsOpen && <div className="flex items-center pt-2"><i className="fi fi-br-angle-down text-2xl cursor-pointer" onClick={() => setIsOtherOptionsOpen(false)}></i></div>}
                {!isOtherOptionsOpen && <div className="flex items-center pt-2"><i className="fi fi-br-angle-right text-2xl cursor-pointer" onClick={() => setIsOtherOptionsOpen(true)}></i></div>}
            </div>
            <CustomHr />

            {
                isOtherOptionsOpen && <div className="w-full lg:w-[800px] mb-8">

                    {/* Programma e durata */}
                    {/* Di questi elementi crea dei componenti a se */}
                    <div className="flex flex-col p-2 gap-2 w-full lg:w-fit">
                        <label htmlFor="description">Programma e durata</label>
                        <div className="flex gap-2 max-w-[800px] lg:w-[800px]">
                            <input type="text" className="flex-grow" onChange={handleProgramInput} value={programInput ? programInput : ''} />
                            {programInput && <button className="w-[72px] h-[72px] rounded-lg border-2 border-[#225424] text-[#225424] flex justify-center items-center text-4xl pb-1" onClick={addProgramToInputData}>+</button>}
                            {!programInput && <button className="w-[72px] h-[72px] rounded-lg border-2 border-neutral-300 text-neutral-300 flex justify-center items-center text-4xl pb-1 cursor-not-allowed">+</button>}
                        </div>
                        <div className="border-2 p-2 flex flex-col gap-2 min-h-[72px] rounded">
                            {
                                inputData && inputData.program && inputData.program.length > 0 && inputData.program.map((element, index) => {
                                    return <ElementLabel key={index} string={element} close={removeProgramFromInputData} />
                                })
                            }
                        </div>
                    </div>

                    {/* Servizi inclusi */}
                    <div className="flex flex-col p-2 gap-2 w-full lg:w-fit">
                        <label htmlFor="description">Servizi inclusi</label>
                        <div className="flex gap-2 max-w-[800px] lg:w-[800px]">
                            <input type="text" className="flex-grow" onChange={handleServiceIncludedInput} value={serviceIncludedInput ? serviceIncludedInput : ''} />
                            {serviceIncludedInput && <button className="w-[72px] h-[72px] rounded-lg border-2 border-[#225424] text-[#225424] flex justify-center items-center text-4xl pb-1" onClick={addServiceIncludedToInputData}>+</button>}
                            {!serviceIncludedInput && <button className="w-[72px] h-[72px] rounded-lg border-2 border-neutral-300 text-neutral-300 flex justify-center items-center text-4xl pb-1 cursor-not-allowed">+</button>}
                        </div>
                        <div className="border-2 p-2 flex flex-col gap-2 min-h-[72px] rounded">
                            {
                                inputData && inputData.servicesIncluded && inputData.servicesIncluded.length > 0 && inputData.servicesIncluded.map((element, index) => {
                                    return <ElementLabel key={index} string={element} close={removeServiceIncludedFromInputData} />
                                })
                            }
                        </div>
                    </div>

                    {/* Accessibilità */}
                    <div className="flex flex-col p-2 gap-2 w-full lg:w-fit">
                        <label htmlFor="description">Accessibilità</label>
                        <div className="flex gap-2 max-w-[800px] lg:w-[800px]">
                            <input type="text" className="flex-grow" onChange={handleAccessibilityInput} value={accessibilityInput ? accessibilityInput : ''} />
                            {accessibilityInput && <button className="w-[72px] h-[72px] rounded-lg border-2 border-[#225424] text-[#225424] flex justify-center items-center text-4xl pb-1" onClick={addAccessibilityToInputData}>+</button>}
                            {!accessibilityInput && <button className="w-[72px] h-[72px] rounded-lg border-2 border-neutral-300 text-neutral-300 flex justify-center items-center text-4xl pb-1 cursor-not-allowed">+</button>}
                        </div>
                        <div className="border-2 p-2 flex flex-col gap-2 min-h-[72px] rounded">
                            {
                                inputData && inputData.accessibility && inputData.accessibility.length > 0 && inputData.accessibility.map((element, index) => {
                                    return <ElementLabel key={index} string={element} close={removeAccessibilityFromInputData} />
                                })
                            }
                        </div>
                    </div>

                    {/* Cancellazione/Rimborso */}
                    <div className="flex flex-col p-2 gap-2 w-full lg:w-fit">
                        <label htmlFor="description">Cancellazione e rimborso</label>
                        <div className="flex gap-2 max-w-[800px] lg:w-[800px]">
                            <input type="text" className="flex-grow" onChange={handleCancellationInput} value={cancellationInput ? cancellationInput : ''} />
                            {cancellationInput && <button className="w-[72px] h-[72px] rounded-lg border-2 border-[#225424] text-[#225424] flex justify-center items-center text-4xl pb-1" onClick={addCancellationToInputData}>+</button>}
                            {!cancellationInput && <button className="w-[72px] h-[72px] rounded-lg border-2 border-neutral-300 text-neutral-300 flex justify-center items-center text-4xl pb-1 cursor-not-allowed">+</button>}
                        </div>
                        <div className="border-2 p-2 flex flex-col gap-2 min-h-[72px] rounded">
                            {
                                inputData && inputData.cancellation && inputData.cancellation.length > 0 && inputData.cancellation.map((element, index) => {
                                    return <ElementLabel key={index} string={element} close={removeCancellationFromInputData} />
                                })
                            }
                        </div>
                    </div>

                    {/* Noleggio attrezzatura */}
                    <div className="flex flex-col p-2 gap-2 w-full lg:w-fit">
                        <label htmlFor="description">Noleggio attrezzatura</label>
                        <div className="flex gap-2 max-w-[800px] lg:w-[800px]">
                            <input type="text" className="flex-grow" onChange={handleRentInput} value={rentInput ? rentInput : ''} />
                            {rentInput && <button className="w-[72px] h-[72px] rounded-lg border-2 border-[#225424] text-[#225424] flex justify-center items-center text-4xl pb-1" onClick={addRentToInputData}>+</button>}
                            {!rentInput && <button className="w-[72px] h-[72px] rounded-lg border-2 border-neutral-300 text-neutral-300 flex justify-center items-center text-4xl pb-1 cursor-not-allowed">+</button>}
                        </div>
                        <div className="border-2 p-2 flex flex-col gap-2 min-h-[72px] rounded">
                            {
                                inputData && inputData.equipmentRentInfo && inputData.equipmentRentInfo.length > 0 && inputData.equipmentRentInfo.map((element, index) => {
                                    return <ElementLabel key={index} string={element} close={removeRentFromInputData} />
                                })
                            }
                        </div>
                    </div>

                    {/* Attrezzature presenti in loco */}
                    <div className="flex flex-col p-2 gap-2 w-full lg:w-fit">
                        <label htmlFor="description">Attrezzature presenti in loco</label>
                        <div className="flex gap-2 max-w-[800px] lg:w-[800px]">
                            <input type="text" className="flex-grow" onChange={handleOnsiteEquipmentInput} value={onsiteEquipmentInput ? onsiteEquipmentInput : ''} />
                            {onsiteEquipmentInput && <button className="w-[72px] h-[72px] rounded-lg border-2 border-[#225424] text-[#225424] flex justify-center items-center text-4xl pb-1" onClick={addOnsiteEquipmentToInputData}>+</button>}
                            {!onsiteEquipmentInput && <button className="w-[72px] h-[72px] rounded-lg border-2 border-neutral-300 text-neutral-300 flex justify-center items-center text-4xl pb-1 cursor-not-allowed">+</button>}
                        </div>
                        <div className="border-2 p-2 flex flex-col gap-2 min-h-[72px] rounded">
                            {
                                inputData && inputData.onsiteEquipment && inputData.onsiteEquipment.length > 0 && inputData.onsiteEquipment.map((element, index) => {
                                    return <ElementLabel key={index} string={element} close={removeOnsiteEquipmentToInputData} />
                                })
                            }
                        </div>
                    </div>

                    {/* Avvertenze */}
                    <div className="flex flex-col p-2 gap-2 w-full lg:w-fit">
                        <label htmlFor="description">Avvertenze</label>
                        <div className="flex gap-2 max-w-[800px] lg:w-[800px]">
                            <input type="text" className="flex-grow" onChange={handlePrecautionsInput} value={precautionsInput ? precautionsInput : ''} />
                            {precautionsInput && <button className="w-[72px] h-[72px] rounded-lg border-2 border-[#225424] text-[#225424] flex justify-center items-center text-4xl pb-1" onClick={addPrecautionToInputData}>+</button>}
                            {!precautionsInput && <button className="w-[72px] h-[72px] rounded-lg border-2 border-neutral-300 text-neutral-300 flex justify-center items-center text-4xl pb-1 cursor-not-allowed">+</button>}
                        </div>
                        <div className="border-2 p-2 flex flex-col gap-2 min-h-[72px] rounded">
                            {
                                inputData && inputData.precautions && inputData.precautions.length > 0 && inputData.precautions.map((element, index) => {
                                    return <ElementLabel key={index} string={element} close={removePrecautionFromInputData} />
                                })
                            }
                        </div>
                    </div>

                    {/* Technical */}
                    <div className="flex flex-col p-2 gap-2 w-full lg:w-fit">
                        <label htmlFor="description">Dettagli tecnici</label>
                        <div className="flex gap-2 max-w-[800px] lg:w-[800px]">
                            <input type="text" className="flex-grow" onChange={handleTechnicalInput} value={technicalInput ? technicalInput : ''} />
                            {technicalInput && <button className="w-[72px] h-[72px] rounded-lg border-2 border-[#225424] text-[#225424] flex justify-center items-center text-4xl pb-1" onClick={addTechnicalToInputData}>+</button>}
                            {!technicalInput && <button className="w-[72px] h-[72px] rounded-lg border-2 border-neutral-300 text-neutral-300 flex justify-center items-center text-4xl pb-1 cursor-not-allowed">+</button>}
                        </div>
                        <div className="border-2 p-2 flex flex-col gap-2 min-h-[72px] rounded">
                            {
                                inputData && inputData.technical && inputData.technical.length > 0 && inputData.technical.map((element, index) => {
                                    return <ElementLabel key={index} string={element} close={removeTechnicalFromInputData} />
                                })
                            }
                        </div>
                    </div>

                    {/* Aggiungi altre categorie */}
                    <div className="flex flex-col p-2 gap-2 w-full lg:w-fit">
                        <label htmlFor="description">Aggiungi altre categorie</label>
                        <div className="flex gap-2 max-w-[800px] lg:w-[800px]">
                            <input type="text" className="flex-grow" onChange={handleAddCategoryInput} value={addCategoryInput ? addCategoryInput : ''} />
                            {addCategoryInput && <button className="w-[72px] h-[72px] rounded-lg border-2 border-[#225424] text-[#225424] flex justify-center items-center text-4xl pb-1" onClick={addCategoryToInputData}>+</button>}
                            {!addCategoryInput && <button className="w-[72px] h-[72px] rounded-lg border-2 border-neutral-300 text-neutral-300 flex justify-center items-center text-4xl pb-1 cursor-not-allowed">+</button>}
                        </div>
                        <div className="border-2 p-2 flex flex-col gap-2 min-h-[72px] rounded">
                            {
                                inputData && inputData.category && inputData.category.length > 0 && inputData.category.map((element, index) => {
                                    return <ElementLabel key={index} string={element} close={removeCategoryFromInputData} />
                                })
                            }
                        </div>
                    </div>

                    <AddCustomOptions inputData={inputData} setInputData={setInputData} />

                    {/* Condizioni meteorologiche */}
                    <div className={`border-2 rounded p-2 flex items-center gap-2 my-4 ${inputData.isByWeather ? 'border-[#225424]' : ''}`}>
                        <input type="checkbox" id="isByWeather" onChange={handleInputData} />
                        <label htmlFor="">L'attività non si svolgerà in caso di pioggia</label>
                    </div>
                    {/* Attività esclusiva */}
                    <div className={`border-2 rounded p-2 flex items-center gap-2 my-4 ${inputData.isExclusive ? 'border-[#225424]' : ''}`}>
                        <input type="checkbox" id="isExclusive" onChange={handleInputData} />
                        <label htmlFor="">Attività esclusiva</label>
                    </div>

                </div>
            }

            {/* Termini e condizioni */}
            <CustomHr />
            <div className="w-full lg:w-[800px]">
                <input type="checkbox" /> <label htmlFor="">Ho letto i <span className="text-[#225424] font-bold cursor-pointer">termini e condizioni</span></label>
            </div>
            <div className="w-full lg:w-[800px]">
                <input type="checkbox" /> <label htmlFor="">Accetto la <span className="text-[#225424] font-bold  cursor-pointer">Privacy & Policy</span></label>
            </div>

            {/* Bozza o pubblico */}
            <div className="flex flex-col gap-16 mt-8">
                <div className="flex flex-col gap-2">
                    <label htmlFor="isActive">Seleziona la modalità di salvataggio</label>
                    <select id="isActive" className="w-48" onChange={handleInputData} value={inputData.isActive ? 'Pubblico' : 'Bozza'}>
                        <option value="Bozza">Bozza</option>
                        <option value="Pubblico">Pubblico</option>
                    </select>
                    <div className="w-full lg:w-[800px]">
                        <p>Tenendo la modalità 'Bozza' l'attività non verrà visualizzata dagli utenti, ma verrà comunque salvata e potrete visualizzarla nel vostro elenco di gestione attività, modificarla e pubblicarla in un secondo momento.</p>
                    </div>
                </div>

                {/* Suggerito del mese */}
                <div className="w-full lg:w-[800px] flex gap-2 border-2 p-2 rounded">
                    <input type="checkbox" onChange={handleInputData} id="isMonthAdviced" checked={inputData.isMonthAdviced} />
                    <label htmlFor="isMonthAdviced">Imposta l'attività fra le suggerite del mese</label>
                </div>

                {/* Instagrammers */}
                <div className="w-full lg:w-[800px] flex gap-2 border-2 p-2 rounded mt-[-32px]">
                    <input type="checkbox" onChange={handleInputData} id="isForInstagrammers" checked={inputData.isForInstagrammers} />
                    <label htmlFor="isMonthAdviced">Imposta l'attività come adatta per produrre contenuti Instagram</label>
                </div>

                {/* External Paid */}
                <div className="w-full lg:w-[800px] flex gap-2 border-2 p-2 rounded mt-[-32px]">
                    <input type="checkbox" onChange={handleInputData} id="isExternalPaid" checked={inputData.isExternalPaid} />
                    <label htmlFor="isExternalPaid">Imposta l'attività come a pagamento esterno</label>
                </div>

                {/* SELEZIONA AZIENDA */}
                <div className="flex flex-col gap-2">
                    <label htmlFor="company">Associa un'azienda a questa attività</label>
                    <select id="company" value={inputData.company} onChange={handleInputData}>
                        <option value="Nessuna">Nessuna azienda associata a questa attività</option>
                        {
                            companiesData && companiesData.length > 0 && companiesData.map((element, index) => {
                                if (element.stripeAccountId) {
                                    return <option key={index} value={element._id}>{element.companyName}</option>
                                }
                            })
                        }
                    </select>
                    <AlertMessage message="Nell'elenco appariranno soltanto le aziende che hanno l'account custom di Stripe attivo" />
                    <AlertMessage message="Se l'azienda che cercate non compare nell'elenco, andate alla pagina di visualizzazione dell'azienda e confermate i suoi dati tramite il link di Stripe" />
                </div>

            </div>




            <div className="mt-8">
                {fetchStatus === 'idle' && isFieldsError && <h4 className="text-red-500 mb-4">Compila tutti i campi obbligatori</h4>}
                {fetchStatus === 'idle' && !isFieldsError && <div className="w-full"><GreenButton text={isEditMode ? 'Salva modifiche' : 'Salva attività'} isMobileFull click={handleCheckFieldsAndSendData} /></div>}
                {fetchStatus === 'loading' && <Loader />}
                {fetchStatus === 'succeeded' && !isEditMode && <h3>Nuova attività inserita correttamente, attendi il refresh della pagina</h3>}
                {fetchStatus === 'succeeded' && isEditMode && <h3>Attività modificata correttamente, attendi il refresh della pagina</h3>}
                {fetchStatus === 'failed' && <h3>Qualcosa è andato storto, ricarica la pagina e riprova.</h3>}
            </div>
        </PageContainer >
    )
}

export default AddEditActivity;

